module.exports = __webpack_public_path__ + "img/inactiveicon-relationship_chart_icon.9e4b1845.svg";